module.exports = __webpack_public_path__ + "static/media/script.05c1e4e1.svg";